import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/home/Hero";
import { Statement } from "@/components/home/Statement";
import { FlavorZones } from "@/components/home/FlavorZones";
import { DrinkShowcase } from "@/components/home/DrinkShowcase";
import { Rewards } from "@/components/home/Rewards";
import { StoryTeaser, Gallery } from "@/components/home/StoryGallery";
import { LocationsExplorer } from "@/components/site/LocationsExplorer";
import { MaskLines } from "@/components/site/motion";

export default function Home() {
  return (
    <>
      <Seo title="TeaDM — Bubble Tea & Vietnamese Coffee in Northern Virginia" description="Boba milk tea, Vietnamese seasalt coffee, matcha and fruit teas at TeaDM in Falls Church, Fairfax, Vienna and Sterling, VA. Order online for pickup." path="/" />
      <Hero />
      <Statement />
      <FlavorZones />
      <DrinkShowcase />
      <section data-testid="home-locations" className="bg-[#efe4d6] py-24 sm:py-32">
        <div className="wrap">
          <div className="mb-12 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
            <div>
              <p className="eyebrow text-[#ff2e63]">Four TeaDMs across Northern Virginia</p>
              <MaskLines lines={["Find your", "TeaDM."]} className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-7xl lg:text-8xl" />
            </div>
            <Link to="/locations" data-testid="home-all-locations-btn" className="btn btn-ink self-start lg:self-auto">All locations <ArrowRight className="h-4 w-4" /></Link>
          </div>
          <LocationsExplorer />
        </div>
      </section>
      <Rewards />
      <StoryTeaser />
      <Gallery />
    </>
  );
}
